import { MhaStatus } from "@thalamos/aspire-common";
import type { OrganisationConfiguration } from "@thalamos/aspire-common";

// Section 136 is offered as a detention-status filter only when the org both
// displays patient state and calculates 136 status — a 136 filter is meaningless
// without a calculable 136 status to match.
export const section136FilterEnabled = (
  config: OrganisationConfiguration | null | undefined,
): boolean =>
  (config?.section136MhaStatusCalculationEnabled ?? false) &&
  (config?.patientStateEnabled ?? false);

export const defaultMhaStatusFilters = (
  section136Enabled: boolean,
): MhaStatus[] => [
  MhaStatus.Incomplete,
  MhaStatus.Expired,
  MhaStatus.Section17A,
  MhaStatus.Section2,
  MhaStatus.Section3,
  MhaStatus.Section4,
  MhaStatus.Section5_2,
  MhaStatus.Section5_4,
  ...(section136Enabled ? [MhaStatus.Section136] : []),
];
